<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and legend -->
      <b-card-title class="mb-50">
        แสดงสรุปยอดขายสินค้า 10 อันดับ
      </b-card-title>
      <!--/ title and legend -->

      <!-- datepicker -->
      <!-- <div class="d-flex align-items-center">
        <feather-icon icon="CalendarIcon" size="16" />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range' }"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div> -->
      <!-- datepicker -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        type="bar"
        height="350"
        :options="barChart.chartOptions"
        :series="barChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BCardTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import flatPickr from "vue-flatpickr-component";

import store from "@/store";

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VueApexCharts,
    flatPickr,
    BCardTitle,
  },
  data() {
    return {
      rangePicker: ["2019-05-01", "2019-05-10"],
      barChart: {
        series: [],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          colors: "#2b9bf4",
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "80%",
              endingShape: "rounded",
            },
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          dataLabels: {
            enabled: true,
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },
    };
  },

  mounted() {
    this.getReportSummaryBestSellProduct();
  },
  methods: {
    getReportSummaryBestSellProduct() {
      store
        .dispatch("dashboard-seller/getReportSummaryBestSellProduct")
        .then((response) => {
          response.data.data.map((item) => {
            if (this.barChart.series.length == 0) {
              this.barChart.series.push({
                data: [item.productBestSell],
              });
            } else {
              this.barChart.series[0].data.push(item.productBestSell);
            }

            this.barChart.chartOptions.xaxis.categories.push(item.productName);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
